import React, { useContext, useState } from 'react';
import axios from 'axios'
import styles from './clear-orders.module.scss'
import { StateContext, DispatchContext } from 'src/AppContext'
import { IState } from 'src/Interface'
import Button from 'src/components/button/Button';
import { baseApiURL } from 'src/utils/utils'
import { toast } from 'react-toastify';

interface Props {
  close: () => void
  handleClick?: () => void
}

const ClearOrders: React.FunctionComponent<Props> = (props: Props) => {
  const state: IState = useContext(StateContext)
  const dispatch: any = useContext(DispatchContext)
  const [loading, setLoading] = useState(false)

  const clearOrders = () => {
    setLoading(true)
    axios.put(`${baseApiURL()}/orders/clear`, {}, {
      headers: {
        Authorization: `Bearer ${state.user.accessToken}`
      }
    }).then(() => {
      setLoading(false)
      dispatch({
        type: 'SET_USER_ORDERS', userOrders: state.userOrders.filter(order =>
        (order.state !== 'cancelled' &&
          order.state !== 'noshow' &&
          order.state !== 'concluded'
        )
        )
      })
      props.close()
    }).catch((error: any) => {
      if (error.response) {
        toast(error.response.data.message)
      } else {
        toast('Der gik desværre noget galt. Prøv igen om lidt')
      }
      setLoading(false)
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <span className={styles.clearOrdersIcon}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </span>
        {state.userOrders.filter(order =>
        (order.state === 'cancelled' ||
          order.state === 'noshow' ||
          order.state === 'concluded'
        )
        ).length === 1 ?
          <p>Er du sikker på at du vil rydde én afsluttet tur? </p>
          : <p>
            Er du sikker på at du vil rydde {state.userOrders.filter(order =>
            (order.state === 'cancelled' ||
              order.state === 'noshow' ||
              order.state === 'concluded'
            )
            ).length} afsluttede ture?</p>}
      </div>
      <footer className={styles.footer}>
        <Button handleClick={props.close} modifiers='tw-mr-auto' type='secondary' label='Annuller' />
        <Button handleClick={clearOrders} loading={loading} type='destructive' label={state.userOrders.filter(order =>
        (order.state === 'cancelled' ||
          order.state === 'noshow' ||
          order.state === 'concluded'
        )
        ).length === 1 ? 'Ryd afsluttede tur' : 'Ryd afsluttede ture'} />
      </footer>
    </div>
  )
}

export default ClearOrders